import React from "react";
import styles from "./NatureBluePrint.module.css";
// import { useNavigate } from "react-router-dom";



const NatureInnovation = () => {
  // const navigate = useNavigate();

  return (
    <div className={styles.containerBox}>
      <div className={styles.container}>
        <div className={styles.LeftSection}>
          <img loading="lazy" src="Images/section-circle-img.webp" alt="young, athletic woman looking into the distance" />
        </div>
        <div className={styles.RightSection}>

          <div className={styles.content}>
            <img loading="lazy" src="Images/VifilconC-logo.webp" alt="Bruno Vision Care vifilcon C hydrogel delivery system logo" />
            <p> vifilcon C is a first-of-its-kind hydrogel material that uses a unique mechanism.</p>
          </div>
          <div className={styles.content}>
            <img loading="lazy" src="Images/FusionTechnology-logo.webp" alt="Bruno Vision Care FusionTechnology™ Lachryceuticals® natural  substances horizontal logo" className={styles.FusionTechnologyLogo} />
            {/* <p>The FusionTechnology® patented delivery system gradually releases natural polymers Hyaluronic Acid (HA), and Tamarind Seed Polysaccharide (TSP®), which mimic human tears.</p> */}

            <p>During manufacturing, natural bio-copolymers Hyaluronic Acid (HA) and Tamarind Seed Polysaccharide (TSP) are embedded into the vifilcon C hydrogel for hydration.</p>
          </div>
          <div className={styles.content}>
            {/* <a onClick={() => navigate("/fusion-technology")} className={styles.learnMoreText}>LEARN MORE About FusionTechnology™</a> */}
          </div>

        </div>

      </div>
      <div className={styles.RightshapeImg}>
        <img loading="lazy" src="Images/RightShapeImg.png" alt="RightShapeImg" />
      </div>
    </div>
  );
};

export default NatureInnovation;
